import React, { useState, useEffect } from 'react';
import axios from '../axiosConfig';
import GoogleButton from 'react-google-button';
import './AuthPopup.css';

export function LoginForm({ onSwitch, onSuccess, handleGoogleLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/users/sign_in`,
        { user: { email, password } }
      );
      localStorage.setItem('authToken', response.data.token);
      onSuccess(); // Оновлення глобального AuthContext після успішного входу
    } catch (err) {
      console.error('Помилка входу:', err);
      // Extract error message from API response
      let errorMessage = 'Помилка входу. Будь ласка, спробуйте ще раз.';
      if (err.response && err.response.data && err.response.data.error) {
        const apiError = err.response.data.error;
        if (Array.isArray(apiError)) {
          errorMessage = apiError.join(', ');
        } else if (typeof apiError === 'string') {
          errorMessage = apiError;
        }
      }
      setError(errorMessage);
      // Don't call onSuccess on failure - stay on current page, don't navigate
    }
  };

  return (
    <div className="auth-form">
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleLogin}>
        <label>
          Ел. пошта / номер телефону:
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ел. пошта або телефон"
            required
          />
        </label>
        <label>
          Пароль:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
        </label>
        <button type="submit" className="auth-btn">Увійти</button>
      </form>
      <div className="google-container">
        <GoogleButton 
          onClick={handleGoogleLogin} 
          label="Увійти за допомогою Google" 
          style={{ width: '100%' }} 
          className="google-btn-custom"
        />
      </div>
      <p style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '14px', color: '#666' }}>
        Немає акаунту?
      </p>
      <button 
        type="button" 
        onClick={() => {
          setError(''); // Clear error when switching
          onSwitch('register');
        }} 
        className="switch-btn"
        style={{ marginTop: '0.5rem', width: '100%' }}
      >
        Зареєструватися
      </button>
    </div>
  );
}

export function RegistrationForm({ onSwitch, onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors
    
    // Client-side validation (the nickname is generated on the server from the name)
    if (password !== passwordConfirmation) {
      setError('Паролі не співпадають.');
      return;
    }
    
    if (password.length < 6) {
      setError('Пароль повинен містити мінімум 6 символів.');
      return;
    }
    
    try {
      // Реєстрація користувача
      await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/users`, {
        user: { 
          email, 
          password, 
          password_confirmation: passwordConfirmation,
          name: name
        },
      });
      // Автоматичний вхід після успішної реєстрації
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/users/sign_in`,
        { user: { email, password } }
      );
      localStorage.setItem('authToken', response.data.token);
      onSuccess(); // Оновлення глобального AuthContext для відображення стану входу
    } catch (err) {
      console.error('Помилка реєстрації:', err);
      // Extract error message from API response
      let errorMessage = 'Помилка реєстрації. Перевірте введені дані.';
      if (err.response && err.response.data && err.response.data.error) {
        const apiError = err.response.data.error;
        if (Array.isArray(apiError)) {
          errorMessage = apiError.join(', ');
        } else if (typeof apiError === 'string') {
          errorMessage = apiError;
        }
      } else if (err.response && err.response.data && err.response.data.errors) {
        // Handle Rails-style errors
        const errors = err.response.data.errors;
        if (typeof errors === 'object') {
          errorMessage = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
            .join('. ');
        } else if (Array.isArray(errors)) {
          errorMessage = errors.join(', ');
        }
      }
      setError(errorMessage);
    }
  };

  return (
    <div className="auth-form">
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleRegister}>
        <label>
          Ім'я:
          <input 
            type="text" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            placeholder="Введіть ім'я"
            required 
          />
        </label>
        <label>
          Ел. пошта / номер телефону:
          <input 
            type="text" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            placeholder="Введіть ел. пошту / номер телефону"
            required 
          />
        </label>
        <label>
          Пароль:
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            placeholder="Введіть бажаний пароль"
            required 
          />
        </label>
        <label>
          Підтвердіть пароль:
          <input 
            type="password" 
            value={passwordConfirmation} 
            onChange={(e) => setPasswordConfirmation(e.target.value)} 
            placeholder="Повторіть пароль"
            required 
          />
        </label>
        <button type="submit" className="auth-btn">Зареєструватися</button>
      </form>
      <div className="google-container">
        <GoogleButton 
          onClick={() => window.location.href = `${process.env.REACT_APP_API_URL}/api/v1/users/google_oauth`}
          label="Зареєструватися за допомогою Google" 
          style={{ width: '100%' }} 
          className="google-btn-custom"
        />
      </div>
      <p style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '14px', color: '#666' }}>
        Вже маєте акаунт?
      </p>
      <button 
        type="button" 
        onClick={() => {
          setError(''); // Clear error when switching
          onSwitch('login');
        }} 
        className="switch-btn"
        style={{ marginTop: '0.5rem', width: '100%' }}
      >
        Увійти
      </button>
    </div>
  );
}

export default function AuthPopup({ isOpen, onClose, onSuccess }) {
  const [mode, setMode] = useState('login');

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/v1/users/google_oauth`;
  };

  // Reset mode and clear state when popup opens
  useEffect(() => {
    if (isOpen) {
      setMode('login');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="auth-popup-overlay auth-popup-overlay--auth" onClick={onClose}>
      <div className="auth-popup-content auth-popup-content--auth" onClick={(e) => e.stopPropagation()}>
        <button className="auth-popup-close" onClick={onClose} aria-label="Закрити">×</button>
        {/* Brand anchor - shown only on the full-screen mobile page (hidden in the desktop modal via CSS) */}
        <div className="auth-brand" aria-hidden="true">
          <span className="auth-brand__logo">ruben</span>
          <span className="auth-brand__subtitle">Твої улюблені бренди</span>
        </div>
        {mode === 'login' ? (
          <LoginForm onSwitch={setMode} onSuccess={onSuccess} handleGoogleLogin={handleGoogleLogin} />
        ) : (
          <RegistrationForm onSwitch={setMode} onSuccess={onSuccess} />
        )}
      </div>
    </div>
  );
}
